<template>
  <div class="app-page-container app-body row-flex">
    <div class="donotsell-body row-flex-body">
      <h1 class="title">{{ this.$t("requestDataCopy.text1") }}</h1>

      <div class="row-flex-content">
        <div class="step-bar-bg row-flex-left">
          <div class="step-bar">
            <div>{{ this.$t("requestDataCopy.text2") }}</div>
            <div>{{ this.$t("requestDataCopy.text3") }}</div>
            <div>{{ this.$t("requestDataCopy.text4") }}</div>
          </div>
        </div>
        <div class="row-flex-right">
          <input
            class="mint-input email-input"
            type="text"
            v-model="email"
            placeholder="Email"
          />

          <!-- <h3 class="text-danger">{{$t("forbiddenRequest.title")}}</h3>
      <p class="desc"> {{$t("forbiddenRequest.desc")}}  </p>-->
          <!-- 人机校验 -->
          <div
            id="g-recaptcha"
            class="g-recaptcha"
            data-sitekey="6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet"/>
          <button class="game-button primary" @click="submit">
            {{ this.$t("doNotSell.text7") }}
          </button>
        </div>
      </div>
    </div>
    <description></description>
    <footerBar @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
var reCaptchaResponse = "";
import footerBar from "../components/common/footer";
import description from "../components/common/description";
import { Toast } from "mint-ui";
// var moment = require("moment");
export default {
  data() {
    return {
      email: "",
      state: "",
      doNotSell: false,
      optionList: [
        { label: "Opt out", value: true },
        { label: "Opt in", value: false },
      ],
    };
  },
  components: { footerBar, description },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 400);
  },
  methods: {
    showLanguage() {
      this.$emit("showLanguage");
    },
    submit() {
      const _this = this;
      if (
        this.email &&
        !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email)
      ) {
        // 国际邮箱正则
        Toast({
          message: "Invalid email address.",
        });
        return false;
      }
      //  人机校验
      if (!reCaptchaResponse.length && !this.$store.state.autoLogined) {
        Toast({
          message: this.$t("toast.follow"),
        });
        return false;
      }
      this.$axios({
        method: "post",
        url: "/privacy/prepare/data",
        data: {
          grecaptcha: reCaptchaResponse,
          pinToken: _this.$cookie.get("token"),
          ua: navigator.userAgent || "",
          mail: _this.email,
        },
      })
        .then((res) => {
          if (res.status === 200 && res.data.c === 0) {
            _this.$store.state.requestDataState = 1;
            // TODO
            _this.$router.push("./Home");
          } else {
            Toast({
              message: res.data.d ? res.data.d : "",
            });
          }
        })
        .catch(() => {
          Toast({
            message: this.$t("toast.error"),
          });
        });
    },
    init() {
      this.doNotSell = this.$store.state.doNotSell || false;
      if (this.$store.state.autoLogined) {
        return;
      }
      window.grecaptcha.render("g-recaptcha", {
        sitekey: "6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet",
        callback: function (response) {
          reCaptchaResponse = response;
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.donotsell-body {
  padding: 0 0 0 0;
  box-sizing: border-box;
  background: #fff;
  min-height: 100%;
  width: 100%;
  text-align: left;
  max-width: 1020px;
  margin: 0 auto;

  .title {
         padding-top: 0.5rem;
    font-size: 0.53rem;
    font-weight: bold;
    margin-bottom: 0.42rem;
    @media only screen and (min-device-width: 700px) and (max-device-width: 1024px) and (orientation: portrait) {
      margin-top: 2rem;
    }
  }
  .notice-box {
    padding: 0.2rem;
    background-color: #fff3cd;
    border: 2px solid #feeeba;
    box-sizing: border-box;
    border-radius: 3px;
    color: #846305;
    font-size: 0.3rem;
  }
  .divide-line {
    width: 100%;
    margin: 0.4rem auto;
    border-top: 1px solid #9e9e9e;
  }
  .game-button {
    width: 100%;
  }
}
.step-bar-bg {
  background: #f1f1f1;
  border-radius: 0.32rem;
  padding: 0.42rem;
      margin-bottom: 0.42rem;
}
.step-bar {
  // margin-top: 0.32rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  & > div {
    flex: 1;
    border-left: 1px dashed #5d7fef;
    position: relative;
    font-size: 0.3rem;
    padding: 0 0.2rem 0.5rem 0.42rem;
    &:last-child {
      border: none;
      padding-bottom: 0;
    }
    &::before {
      content: "";
      display: inline-block;
      width: 0.42rem;
      height: 0.42rem;
      border-radius: 100%;
      background: #5d7fef;
      position: absolute;
      left: -0.22rem;
      text-align: center;
      color: #ffffff;
      line-height: 0.42rem;
    }
  }
  & > div:first-child {
    &::before {
      content: "1";
    }
  }
  & > div:nth-child(2) {
    &::before {
      content: "2";
    }
  }
  & > div:nth-child(3) {
    &::before {
      content: "3";
    }
  }
}

p {
  text-indent: 2em;
  font-size: 0.3rem;
}


 
</style>
